import type { FaireProductEntity } from "../../entity_types/product";

export const p_6rmtm2zxry: FaireProductEntity = {
  token: "p_6rmtm2zxry",
  type: "product",
  name: "Squisies Dundun Animals - Display 16 units",
  brandToken: "b_wh4df8t9g6",
  brandName: "Triciclo Editores",
  imageUrl:
    "https://cdn.faire.com/fastly/74c0682593ddc2f1a263dfa6b12de6498e6e28a8c93da17c49a22f7eb232f265.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5557ba6d757a7f1b4fed0567a728b6e9dda306dd66df9e70478fb005f047659.jpeg",
    "https://cdn.faire.com/fastly/4173cd0ea41071272c5c83c349ba1ac16a932456ba8e7ed24fd752841f8eede1.jpeg",
    "https://cdn.faire.com/fastly/e4b0dfde06a5df265a074574ee4c2b0ed944a6cf479af9ead0a0daecff36acdd.jpeg",
    "https://cdn.faire.com/fastly/bb64ee9f644057b82ef640ece981cfa2192da5e0c17f147ed35b262265e7b1f5.jpeg",
    "https://cdn.faire.com/fastly/35ee1d1904946f36091522ecd4bada028f6ade79cb9727ef7b0f7630bc0f84a7.jpeg",
    "https://cdn.faire.com/fastly/a0e85c175da5b536c6e3d911cf835e415b0af4a0cf71df747cf0ace9c2100770.jpeg",
    "https://cdn.faire.com/fastly/4cabedba29ada88cc5b3477f232100c170a39f65b4c210d127ceb7e85eb58bf5.jpeg",
    "https://cdn.faire.com/fastly/9a28bc8f8a0fc27c57488ce5c7980d19355945f98fe8024a875756617b155834.jpeg",
    "https://cdn.faire.com/fastly/6ce109c5065e965aa7fae5f0ff44cd580bcb6e3eaf171b6caf5ea0ac56af1af1.jpeg",
    "https://cdn.faire.com/fastly/35ffe11c870ce5262f60b9aa27ce0d0b62433ae049a45587d8096e3e93b5c0c2.jpeg",
  ],
  priceDollars: 1.74,
  description:
    'The adorable little animals and fantasy characters from the DUNDUN series are now available in a trendy format. With rounded shapes, vibrant colors, and super-cool outfits, they\'re soft and squishy, have a "slow rising" effect, and a delightful vanilla scent.\nEach flow pack includes a pair of kawaii-style squishies, and there are 16 to collect.\nFlow pack with a transparent window.\nMinimum order: 8 displays.',
  tags: [],
  msrpDollars: 3.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:41.805Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
